import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useTestCampaignContext } from './testCampaignContext'
import { canEnableTestCampaign } from './testCampaignUtils'
import { SecondaryButton } from 'components/Shared/Button'

export default function TestCampaignButton({ assets }) {
  const { t } = useTranslation()
  const { openModal } = useTestCampaignContext()

  const isEnabled = canEnableTestCampaign(assets)
  return (
    <SecondaryButton
      className="meta_connection__buttons__item"
      onClick={openModal}
      text={t('Settings.MetaAccess.TestCampaign.runTestCampaign', 'Run Test Campaign')}
      disabled={!isEnabled}
      disabledTitle={t(
        'Settings.MetaAccess.TestCampaign.runTestCampaignDisabled',
        'Connect at least 1 Ad Account and 1 Page to run test campaign',
      )}
      color="orange"
      fullWidth={false}
      size="small"
    />
  )
}

TestCampaignButton.propTypes = {
  assets: PropTypes.array.isRequired,
}
